import React from "react";

const Reports = ({ fill }: { fill: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3445 2.3175H3.75V18.6825H17.25V8.046M11.3445 2.3175L17.25 8.046M11.3445 2.3175V8.046H17.25M6.75 21.75H20.25V11.25M6 11.25H15M6 7.5H9M6 15H15"
      stroke={fill}
      strokeLinejoin="round"
    />
  </svg>
);

export default Reports;
